module.exports = __webpack_public_path__ + "static/media/4.7d667250.png";